import React from "react";
import "./sidebar.css";
import { useLocation } from "react-router-dom";
import newLogo from "../../../../assets/images/newLogo.png";
import dashboard from "../../../../assets/images/Vector.png";
import dropoff from "../../../../assets/images/location.png";
import history from "../../../../assets/images/history.png";
import support from "../../../../assets/images/support.png";
import settings from "../../../../assets/images/settings.png";
import { FaTimes } from "react-icons/fa";

const Sidebar = ({ sidebarOpen, closeSidebar }) => {
  const location = useLocation();
  return (
    <div className={sidebarOpen ? "sidebar_responsive" : ""} id="sidebar">
      <div className="sidebar__title">
        <div className="sidebar__img">
          <img src={newLogo} alt="logo" />
        </div>
        <div
          style={{
            backgroundColor: "#c4da00",
            width: "30px",
            height: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
          }}
          className="nav_icon nav_icons"
        >
          <FaTimes
            id="sidebarIcon"
            onClick={() => closeSidebar()}
            style={{ color: "#fff" }}
          />
        </div>
      </div>

      <div className="sidebar__menu">
        <div
          className={`${location.pathname === "/factory"
            ? "active-menu_link"
            : "sidebar__link"
            }`}
        >
          <div className="icon__img">
            <img src={dashboard} />
          </div>

          <a href="/factory">Reports</a>
        </div>

        <div
          className={`${location.pathname === "/factory/evacuation"
            ? "active-menu_link"
            : "sidebar__link"
            }`}
        >
          <div className="icon__img">
            <img src={dropoff} alt="drop" />
          </div>
          <a href="/factory/evacuation">Evacuation Requests</a>
        </div>

        <div
          className={`${location.pathname === "/factory/history"
            ? "active-menu_link"
            : "sidebar__link"
            }`}
        >
          <div className="icon__img">
            <img src={history} alt="history" />
          </div>
          <a href="/factory/history">History</a>
        </div>

        <div
          className={`${location.pathname === "/factory/drivers"
              ? "active-menu_link"
              : "sidebar__link"
            }`}
        >
          <div className="icon__img">
            <img src={history} alt="drivers" />
          </div>
          <a href="/factory/drivers">Drivers</a>
        </div>

        <div
          className={`${location.pathname === "/factory/support"
            ? "active-menu_link"
            : "sidebar__link"
            }`}
        >
          <div className="icon__img">
            <img src={support} alt="support" />
          </div>
          <a href="/factory/support">Support</a>
        </div>

        <div
          className={`${location.pathname === "/factory/settings"
            ? "active-menu_link"
            : "sidebar__link"
            }`}
        >
          <div className="icon__img">
            <img src={settings} alt="settings" />
          </div>
          <a href="/factory/settings">Settings</a>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
